import { Variants } from 'common';
import { useLocation, useNavigate } from 'react-router';

import { IExternalNavigationHook } from 'application/modules/bookingWizard/useCases/hooks/useCaseNavigateTo';
import { WizardStep } from 'domain/entities/WizardStep';
import { AccountRoutes } from 'infrastructure/targets/web/modules/bookingWizard/navigation/BookingWizardRoutes';
import { ManageBookingRoutes } from 'infrastructure/targets/web/modules/bookingWizard/navigation/ManageBookingRoutes';
import { isGenericDuckpin } from 'infrastructure/targets/web/modules/bookingWizard/Steps/SessionLengthStep/helpers';

const isAustralia = import.meta.env.VITE_SENTRY_ENV.endsWith('_au');
const isUae = import.meta.env.VITE_SENTRY_ENV.endsWith('_ae');
const isDuckpin = import.meta.env.VITE_VARIANT === Variants.DUCKPIN;

const useExternalNavigation: IExternalNavigationHook = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const openNewTabAndRedirectToContactPage = () => {
    if (isDuckpin) {
      if (isGenericDuckpin()) {
        openPageInANewTab('https://fiveirongolf.com/contact');
      } else {
        openPageInANewTab('https://www.detroitduckpin.com/#info');
      }
    } else if (isAustralia) {
      openPageInANewTab('https://fiveirongolf.au/contact');
    } else if (isUae) {
      openPageInANewTab('https://www.fiveirongolf.ae/pages/contact');
    } else {
      openPageInANewTab('https://fiveirongolf.com/contact');
    }
  };

  const openEventsInquiryPage = (siteId: number) => {
    const params = `?location_id=${siteId}`;
    if (isAustralia) {
      openPageInANewTab('https://fiveirongolf.au/pages/event-enquiry');
    } else if (isUae) {
      openPageInANewTab('https://tgm36.share.hsforms.com/2OBD9X9amTouhkC86xnlZ5A');
    } else {
      openPageInANewTab(`https://fiveirongolf.com/events-inquiry${params}`);
    }
  };

  const redirectToCreateAccountPage = () => {
    navigateToPage(`${AccountRoutes.CreateAccount}`);
  };

  const openPageInANewTab = (pageUrl: string) => {
    const newWindow = window.open(pageUrl, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  const navigateToPage = (pageSlug: string, state?: Record<string, unknown>) => {
    navigate(pageSlug, { state });
  };

  const redirectToSignInPage = () => {
    if (!location.pathname.includes(WizardStep.preOrderFood)) {
      navigateToPage(AccountRoutes.SignIn);
    }
  };

  const redirectToCheckYourEmailPage = (error?: unknown) => {
    navigateToPage(AccountRoutes.CheckYourEmail, { error: error });
  };

  const redirectToMyBookingsPage = () => {
    navigateToPage(ManageBookingRoutes.Index);
  };

  return {
    openNewTabAndRedirectToContactPage,
    redirectToCreateAccountPage,
    openPageInANewTab,
    navigateToPage,
    redirectToSignInPage,
    redirectToCheckYourEmailPage,
    redirectToMyBookingsPage,
    openEventsInquiryPage,
  };
};

export default useExternalNavigation;
